module.exports = __webpack_public_path__ + "img/range-dx.0831e240.png";